
<div
  :data-component-name="$options.name"
  class="card"
  :class="classObject"
  :style="[
    { 'border-color': content.borderColor },
    { 'background-size': content.backgroundType },
    styleObject,
  ]"
>
  <b-link
    v-if="content.lien && content.lien.field !== 'aucunLien'"
    :id="content['@id']"
    v-bind="jel_getLienBinding(content.lien)"
    :ga-img-name="imageName"
    class="stretched-link offre-speciale"
    :data-tag="`${jel_getNomRouteCourante()} - ${content.titre.replace(/&nbsp;/g, ' ')} - ${
      content.sousTitre
    } - ${content.dataTag}`"
  >
  </b-link>
  <div
    v-if="content.formatAffichage"
    class="content text-left container_media h-100"
    :info-format-affichage="content.formatAffichage"
    :class="[content.formatAffichage + '_container']"
    :ga-img-name="imageName"
    :data-tag="
      'MediaImage' +
      ' ' +
      content.GaLabel +
      ' ' +
      content.formatAffichage.charAt(0).toUpperCase() +
      content.formatAffichage.slice(1) +
      '-' +
      content.dataTag
    "
  >
    <component
      :is="
        'MediaImage' +
        content.formatAffichage.charAt(0).toUpperCase() +
        content.formatAffichage.slice(1)
      "
      :key="content['@id']"
      :content="content"
    >
    </component>

    <div class="text-sizer"></div>
  </div>
</div>
